import { useCallback } from 'react'

import { clearError, setError } from '../reduxes/slices/errors/actions'
import { useDispatchDelegateStore } from '../reduxes/stores/root_store/hooks'

export const useSetError = () => {
  const dispatch = useDispatchDelegateStore()

  return useCallback(
    ({ domId, error, timeout = 3000 }) => {
      dispatch(setError({ domId, error }))
      setTimeout(() => {
        dispatch(clearError(domId))
      }, timeout)
    },
    [dispatch],
  )
}
